
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Vue from 'vue'
import jsonpapi from './../api/jsonpapi.js'

export default {
data() {
return {
toggle: "no",
};
},
directives: {
TransferDom
},
components: {
XDialog
},
props : {
showlogindialog:false,
},
methods:{
hideDialog(){
this.$emit('hidedialog',false)
},
goLogin(){

if (this.toggle == "no" || this.toggle == undefined) {
alert("请阅读并勾选协议");
} else {
this.$emit('hidedialog',false)
location.href = `#/phoneLogin`;
}
},
wxLogin(){

if (this.toggle == "no" || this.toggle == undefined) {
alert("请阅读并勾选协议");
} else {
this.$emit('hidedialog',false)
location.href="https://open.weixin.qq.com/connect/qrconnect?appid=wx900ebe426d97e36f&redirect_uri=http%3a%2f%2fwww.taluo.com%2fwxlogin.html&response_type=code&scope=snsapi_login&state=123456#wechat_redirect"
}
},
qqlogin(){
this.$emit('hidedialog',false)
location.href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100576541&redirect_uri=http%3a%2f%2fwww.taluo.com%2fqqlogin.html&state=123333"
}
}
}



// WEBPACK FOOTER //
// ./src/tlpage/LoginDialog.vue